import CryptoJS from "crypto-js";

const secretKey = "redux-central-system-of-otb"; // Use a strong, unique key

// secureLocalStorage.setItem("acessTokens", JSON.stringify(acessTokens));

const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString); // Convert string back to object/array
};

const encryptData = (data) => {
  const stringData = JSON.stringify(data); // Convert object/array to string
  return CryptoJS.AES.encrypt(stringData, secretKey).toString();
};
let userInfo = localStorage.getItem("userInfo");
let userData = userInfo ? decryptData(userInfo) : null;

let cate = localStorage.getItem("categories");
let catData = cate ? decryptData(cate) : null;
let opt = localStorage.getItem("selectedOpt");

const initialState = {
  user: userData ? userData : null,
  categories: catData ? catData : null,
  selectedOpt: opt ? opt : null,
};

const reducer = (state = initialState, action) => {
  if (action.type === "userLogin") {
    const user = encryptData(action.payload);

    localStorage.setItem("userInfo", user);

    return {
      ...state,
      user: action.payload,
    };
  } else if (action.type === "catStore") {
    const cat = encryptData(action.payload);

    localStorage.setItem("categories", cat);

    return {
      ...state,
      categories: action.payload,
    };
  } else if (action.type === "saveOpt") {
    localStorage.setItem("selectedOpt", action.payload);

    return {
      ...state,
      selectedOpt: action.payload,
    };
  } else if (action.type === "userLogOut") {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("categories");
    localStorage.removeItem("selectedOpt");

    return {
      ...state,
      user: null,
      categories: null,
      selectedOpt: null,
    };
  } else {
    return state;
  }
};
export default reducer;
